import Model from './BaseModel';
import Selection from './Selection';
import BetType from './RaceBetType';
import Result from './Result';
import Promotion from '@/Models/Promotion.js';

export default class Race extends Model {
	resourceName() {
		return 'races';
	}

	fields() {
		return [
			'bonus_disabled',
			'boostable',
			'classification',
			'display_result',
			'distance',
			'featured',
			'fixed_place_divisor',
			'has_fixed_prices',
			'in_review',
			'liabilities',
			'manual_result',
			'meeting',
			'name',
			'number_of_active_runners',
			'number_of_places',
			'number_of_runners',
			'race_number',
			'race_type',
			'start_time',
			'status',
			'visible',
			'unfinalised'
			//'cashout_enabled'
		];
	}

	relationships() {
		return {
			selections: new Selection(),
			result: new Result(),
			bet_types: new BetType(),
			winners: new Selection(),
			promotions: new Promotion()
		};
	}

	// custom update
	update(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'POST',
			data
		});
	}

	unfinalise() {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/unfinalise`,
			method: 'POST',
			data: {}
		});
	}

	abandon() {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/abandon`,
			method: 'POST',
			data: {}
		});
	}

	adjustLiabilityLimit(newSelectionLimit, newMultiSelectionLimit) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/liability_settings`,
			method: 'POST',
			data: {
				win_selection_limit: newSelectionLimit,
				win_multi_selections_limit: newMultiSelectionLimit
			}
		});
	}

	updatePromotion(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/promotion`,
			method: 'PATCH',
			data
		});
	}

	removePromotion(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/promotion`,
			method: 'DELETE',
			data
		});
	}
}
